$(document).ready(function() {


    


    $('#StickyNav').show();
    $('#StickyBar').show();
    //console.log("ready jquer");


    var max_width = 168; // max image width for desktop
    var max_height = 168;


    $('.product-card__image-wrapper img').each(function(i) {

        // if the image is horizontal format
        // make sure it is at max width, adjust height

      
        
                var img_w = parseInt($(this).css('width'));
                var img_h = parseInt($(this).css('height'));
                var ratio = img_w / img_h;
                
                //console.log(img_w, img_h,"ratio", ratio);
            
            if (img_h > img_w) {
                //console.log("portrait");
                // resize it
                var img_w = img_w * ratio;
                var img_h = max_height;
                //console.log("would resize to ", img_w, img_h);
                
                $(this).css('width', img_w);
                $(this).css('height', img_h);

                
                

            } else {
                //console.log("horizontal");
            }


        
        


    });
    
    $('.product-card__overlay').hover(function() {
        var overlay = $(this);
        var productCard = overlay.parent();
        
        var productImg = overlay.parent().find('img');
        $(productImg).css('transition', '.2s linear');
        
        //$(productImg).css('transform', 'rotate(0.5turn)');
        $(productImg).css('transform', 'translate(0, -120px)');


        
        //$(productImg).css('filter', 'blur(0)');
        $(productImg).css('opacity', '1');

        window.setTimeout(reRotate, 200);

        function reRotate() {
            $(productImg).css('transition', '0.3s linear');
            //$(productImg).css('transform', 'rotate(0)');
            $(productImg).css('transform', 'translate(0,-80px)');
            $(productImg).css('opacity', '0.7');
            
        }
        


        //.children[0].children[0].style.filter = 'blur(0px)';

     }, function() {
        //console.log("hover out");
        

    });




    let popupShown = localStorage.getItem("popupWasShown");
    console.log("popup was", popupShown);
    console.log(window.location.href);
    //(popupShown != 1 &&
    //if (window.location.href === 'https://www.fusetronsound.com/') {
    
    if (popupShown != 1) {
        //console.log(window.location.href);
        
        document.getElementById("ac-wrapper").style.display = 'inline';
    
    
    
    } 
    


    
});

$(window).scroll(function() {

    // calculate the percentage the user has scrolled down the page
    var scrollPercent = 100 * $(window).scrollTop() / ($(document).height() - $(window).height());
    

    //    $('.bar-long').css('width', scrollPercent +"%"  );
    
    if (scrollPercent > 50) {
        $('#fusetron-next').hide();
        $('#fusetron-prev').hide();
    }
    else  {
        $('#fusetron-next').show();
        $('#fusetron-prev').show();
    }


});




// statement
function statementAgreed() {
    if (document.getElementById("statementCheckbox").checked === true) {
        localStorage.setItem("popupWasShown",1);
        document.getElementById("ac-wrapper").style.display = 'none';
    } else {
        let value = document.getElementById("statementCheckbox").checked;
        //console.log("VALUE Is ", value);
        
    }
}
